import React from 'react';
import './App.css';
import Header from './Components/Header'
import SearchBar from './Components/SearchBar'
import Footer from './Components/Footer'

function App() {
  return (
    <div className="App">
      <Header />
      <SearchBar />
      <Footer />
    </div>
  );
}

export default App;
